module.exports = __webpack_public_path__ + "static/img/card_add_active.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/card_add_active.png
// module id = 541
// module chunks = 0